// This controller integrates with a Tiptap editor instance via an outlet.
// It is useful when you need to interact with a Tiptap editor from another part of the DOM
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [];
  static outlets = ["tiptap"];

  static values = {
    content: String
  }

  connect() {
    if (!this.hasTiptapOutlet) {
      console.error("No Tiptap outlet found");
    }
  }

  insert(event) {
    event.preventDefault();
    const content = event.currentTarget.dataset.content;

    if (this.hasTiptapOutlet) {
      this.tiptapOutlet.insertContent(content);
    } else {
      console.error("No Tiptap editor found. Make sure the outlet selector is correct.");
    }
  }
}